/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Plugin_Owner_OnlyInputs */



/**
* | output |
* | --- |
* | "Only the account owner can change extra credits." |
*
* @param {Agent_Plugin_Owner_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const agent_plugin_owner_only = /** @type {((inputs?: Agent_Plugin_Owner_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Plugin_Owner_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seul le propriétaire du compte peut modifier les crédits supplémentaires.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur der Kontoinhaber kann zusätzliche Credits ändern.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo il titolare dell'account può modificare i crediti extra.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменять дополнительные кредиты может только владелец аккаунта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo el propietario de la cuenta puede cambiar los créditos adicionales.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("只有账户所有者可以更改额外积分。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("追加クレジットを変更できるのはアカウント所有者のみです。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केवल खाता स्वामी अतिरिक्त क्रेडिट बदल सकता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Só o titular da conta pode alterar os créditos adicionais.")
	return /** @type {LocalizedString} */ ("Only the account owner can change extra credits.")
});